<template>
  <div class="content container-fluid"></div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {};
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data;
    },
    isManager() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.IsManager ? data.IsManager : false;
    },
    isNextManager() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.IsNextManager ? data.IsNextManager : false;
    },
    hasCarparkClaimDelegation() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.HasCarparkClaimDelegation
        ? data.HasCarparkClaimDelegation
        : false;
    },
    hasTimesheetDelegation() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.HasTimesheetDelegation ? data.HasTimesheetDelegation : false;
    },
  },
  created() {
    if (this.tokenObj.Role == "admin") {
      window.location = "/group";
    } else {
      let param = {
        Token: this.tokenObj.Token,
        Company: this.tokenObj.Company,
      };
      API.getMenus(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            let menus = response.data.record;
            if (
              menus.find(
                (c) =>
                  c.Children[0].Name == "Dashboard" &&
                  c.Children[0].Selected == true
              ) != null &&
              (this.isManager ||
                this.isNextManager ||
                this.hasCarparkClaimDelegation ||
                this.hasTimesheetDelegation)
            ) {
              window.location = "/dashboard";
            } else {
              let hasMyBenefitOptionsAccess = false;
              let parent = menus.find((c) => c.Parent == "Benefit");
              if (parent) {
                let child = parent.Children.find(
                  (c) => c.Name == "My Benefit Options" && c.Selected == true
                );
                if (child) hasMyBenefitOptionsAccess = true;
              }
              if (hasMyBenefitOptionsAccess) {
                window.location = "/employeebenefitoption";
              } else {
                for (let menu of menus) {
                  for (let child of menu.Children) {
                    if (child.Selected == true) {
                      let name = child.Name;
                      if (name == "My Insurance and Dependents") {
                        window.location = "/insurancedependent";
                        return;
                      } else if (name == "My Timesheet") {
                        window.location = "/attendance/timesheet";
                        return;
                      } else if (name == "My Monthly Overtime Report") {
                        window.location =
                          "/attendance/report/timesheet/mymonthlyovertime";
                        return;
                      } else if (
                        name ==
                        "My Monthly Overtime, Standby & Shift Allowance Report"
                      ) {
                        window.location =
                          "/attendance/report/timesheet/mymonthlyotstandbyshiftallowance";
                        return;
                      } else if (
                        name == "My Staff Timesheet List" &&
                        this.isManager
                      ) {
                        window.location = "/attendance/list/timesheet";
                        return;
                      } else if (
                        name == "My Staff Monthly Overtime Report" &&
                        this.isManager
                      ) {
                        window.location =
                          "/attendance/report/timesheet/monthlyovertime";
                        return;
                      } else if (
                        name ==
                          "My Staff Monthly Overtime, Standby & Shift Allowance Report" &&
                        this.isManager
                      ) {
                        window.location =
                          "/attendance/report/timesheet/monthlyotstandbyshiftallowance";
                        return;
                      } else if (name == "My Car Park Claim") {
                        window.location = "/carpark/myclaim";
                        return;
                      } else if (name == "View Car Park Claim") {
                        window.location = "/carpark/viewclaims";
                        return;
                      } else if (
                        name == "My Staff Car Park Claim" &&
                        this.isManager
                      ) {
                        window.location = "/carpark/mystaffcarparkclaim";
                        return;
                      } else if (
                        name == "My Staff Monthly Car Park Claim Report" &&
                        this.isManager
                      ) {
                        window.location = "/carpark/monthlyclaimreport";
                        return;
                      } else if (name == "Submit Corporate Pass") {
                        window.location = "/corppass/submit";
                        return;
                      } else if (name == "My Booking History") {
                        window.location = "/corppass/bookinghistory";
                        return;
                      } else if (name == "My Leave of Absence") {
                        window.location = "/leave/myleave";
                        return;
                      } else if (name == "My Leave of Absence Report") {
                        window.location = "/leave/myleavereport";
                        return;
                      } else if (
                        name == "My Staff Leave of Absence" &&
                        this.isManager
                      ) {
                        window.location = "/leave/mystaffleave";
                        return;
                      } else if (
                        name == "My Staff Leave of Absence Report" &&
                        this.isManager
                      ) {
                        window.location = "/leave/mystaffleavereport";
                        return;
                      } else if (name == "My FWA") {
                        window.location = "/fwa/form";
                        return;
                      } else if (name == "My FWA Record") {
                        window.location = "/fwa/my-fwa-record";
                        return;
                      } else if (
                        name == "My Staff FWA Record" &&
                        (this.isManager || this.isNextManager)
                      ) {
                        window.location = "/fwa/my-staff-fwa-record";
                        return;
                      } else if (
                        name == "My Staff FWA Report" &&
                        (this.isManager || this.isNextManager)
                      ) {
                        window.location = "/fwa/report";
                        return;
                      } else if (name == "My Leave Utilization Report") {
                        window.location = "/leave-utilization-report/my-report";
                        return;
                      } else if (
                        name == "My Staff Leave Utilization Report" &&
                        this.isManager
                      ) {
                        window.location =
                          "/leave-utilization-report/my-staff-report";
                        return;
                      } else if (name == "Delegation" && this.isManager) {
                        window.location = "/delegation";
                        return;
                      }
                    }
                  }
                }
                // window.location = "/home";
              }
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Account/Home.vue